// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3L1Ll","label":"Section_label__26IbI","contentWrap":"Section_contentWrap__1Nrzt","footer":"Section_footer__1XbYb","footerInner":"Section_footerInner__17ks4"};